// extracted by mini-css-extract-plugin
export default {"link":"ImportLog_link__dOItc"};